import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import { LOCAL_ACTIONS, openSupportChat } from "../../agent/agentContract";

const CtaChipsBlock = observer(({ block }) => {
  const history = useHistory();

  const handleClick = chip => {
    if (chip.actionId === LOCAL_ACTIONS.NAVIGATE && chip.path) {
      history.push(chip.path);
    }
    if (chip.actionId === LOCAL_ACTIONS.CONTACT_SUPPORT) {
      openSupportChat();
    }
    if (chip.actionId === LOCAL_ACTIONS.ADD_CONTACTS && chip.sequenceId) {
      // Handled entirely by the app: list the contacts bound to this sequence.
      copilotStore.listContactsForSequence(chip.sequenceId);
      return;
    }
    copilotStore.clickCta(block.id, chip);
  };

  return (
    <div className="copilotCtaChips">
      {(block.chips || []).map(chip => {
        const consumed =
          block.clickedActionId && block.clickedActionId === chip.actionId;
        const loading =
          chip.actionId === LOCAL_ACTIONS.ADD_CONTACTS &&
          Boolean(chip.sequenceId) &&
          copilotStore.addContactsPending === chip.sequenceId;
        // Local chips (view table, navigate) stay usable after an agent
        // action from the same row has been consumed.
        const isLocal =
          chip.actionId === LOCAL_ACTIONS.VIEW_TABLE ||
          chip.actionId === LOCAL_ACTIONS.NAVIGATE ||
          chip.actionId === LOCAL_ACTIONS.CONTACT_SUPPORT ||
          chip.actionId === LOCAL_ACTIONS.ADD_CONTACTS;
        return (
          <button
            type="button"
            key={chip.actionId + (chip.label || "")}
            className={`copilotCtaChips__chip ${
              chip.style === "primary" ? "primary" : ""
            } ${consumed ? "consumed" : ""}`}
            disabled={
              loading ||
              copilotStore.streaming ||
              (Boolean(block.clickedActionId) && !isLocal)
            }
            onClick={() => handleClick(chip)}
          >
            {chip.icon && !consumed && !loading && (
              <i className="material-icons-outlined">{chip.icon}</i>
            )}
            {loading && <span className="copilotCtaChips__spin" />}
            <span>{loading ? "Loading contacts…" : chip.label}</span>
            {consumed && <i className="material-icons-outlined">check</i>}
          </button>
        );
      })}
    </div>
  );
});

export default CtaChipsBlock;
